import { useState } from 'react'
import { Alert, IconButton } from '~/shared/ui'

export function ProcessingAlert({ className }: { className?: string }) {
  const [isHidden, setIsHidden] = useState(false)

  if (isHidden) return null

  return (
    <Alert
      className={className}
      appearance="ERROR"
      materialIcon="error"
      action={
        <IconButton
          className="text-alert-error-message"
          size="medium"
          container="small"
          materialIcon="close"
          onClick={() => setIsHidden(true)}
        />
      }
    >
      opti is processing this document and it's not ready for review. Some functionality may not be
      available.
    </Alert>
  )
}
